import { ngModuleRegistrar } from '../../helpers';
import { AuthService } from './index';
import { AppPropertyFilterService } from '../../app/services';

export default ngModuleRegistrar('service', {
    AuthService,
    AppPropertyFilterService,
});



// WEBPACK FOOTER //
// ./src/auth/services/register.js